module.exports = __webpack_public_path__ + "img/tips-urgent.eb6faaf8.svg";